import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Thumbnail } from './thumbnail';
import { Observable } from 'rxjs/Observable'
import { AngularFirestore } from '@angular/fire/firestore';
import { saveQuizSelection, saveQuizVideoSelection, fetchQuizStats } from '../apiService';
import youtubeVideos from './youtubeVideos';
import confetti from 'canvas-confetti';

function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}

const count = 200;
const confettiDefaults = {
  origin: { y: 0.7 }
};

const audioIncorrectAnswer = new Audio('/assets/incorrect-answer.wav');
const audioCorrectAnswer = new Audio('/assets/correct-answer.wav');

function fireConfetti(particleRatio, opts) {
  confetti(Object.assign({}, confettiDefaults, opts, {
    particleCount: Math.floor(count * particleRatio)
  }));
}


const shuffledYoutubeVideos = shuffleArray(youtubeVideos);

@Component({
  selector: 'app-quiz',
  templateUrl: './quiz.component.html',
  styleUrls: ['./quiz.component.scss']
})
export class QuizComponent implements OnInit {

  youtube:any
  youtubeThumbnails: any;
  position:any;
  showDemographics:any;
  askSelectVideo:any;
  candidateSelected:any;
  answersCounter:any;
  correctCounter:any;
  bgColor:any;
  goodGuess:any;
  badGuess:any;
  feedback: any;
  itemclass:any;
  allUsersCounter: any;
  allAnswersCounter: any;
  allCorrectCounter: any;
  averageScore: any;
  currentScore: any;

  constructor(private http:HttpClient, private firestore: AngularFirestore) { 
    this.position = 0;
    this.showDemographics = false;
    this.askSelectVideo = false;
    this.candidateSelected = '';
    this.answersCounter= 0;
    this.correctCounter=0;
    this.bgColor = '#f3de16';
    this.goodGuess = ["You're right!", "Correct!", "Good guess,"];
    this.badGuess = ["Actually,", "Sorry,", "Afraid not,"];
    this.feedback = '';
    this.allUsersCounter = 0;
    this.allAnswersCounter = 0;
    this.allCorrectCounter = 0;
    this.averageScore = 0;

    fetchQuizStats(firestore).then((response) => {
      const stats = response.data() as any;
      this.allAnswersCounter = stats.answers;
      this.allCorrectCounter = stats.correctAnswers;
      this.allUsersCounter = stats.totalUsers;
      this.updateScore();
    });
  }

  updateScore() {
    this.currentScore = Math.round((this.correctCounter / this.answersCounter) * 100);
    this.averageScore = Math.round((this.allCorrectCounter / this.allAnswersCounter) * 100);
  }

  ngOnInit(): void {
    this.youtubeThumbnails = []
    this.getYoutubeVideos()
    this.getYoutubeThumbnail()
  }

  getYoutubeThumbnail() {
    for (var i = 0; i < this.youtube[this.position].videos.length; i++){
      var tmpVideo = this.youtube[this.position].videos[i]
      this.http.get('https://www.youtube.com/oembed?format=json&url='+tmpVideo).subscribe( function (tmpVideo, response) {
        this.youtubeThumbnails.push({thumbnail:response, url:tmpVideo});
    }.bind(this, tmpVideo));
    }
  }

  getYoutubeVideos() {
    this.youtube = shuffledYoutubeVideos;
  }

  onSelect(selection) {
    // Add here post to save answer?
    this.askSelectVideo = true;
    this.candidateSelected = selection;
    saveQuizSelection(this.firestore, {
      videoProfileId: this.youtube[this.position].id,
      candidateSelected: selection,
      isCorrect: this.candidateSelected == this.youtube[this.position].demographics.candidate
    });
  }

  selectVideoSupports(url) {
    if(this.askSelectVideo) {
      // save user selection to server
      saveQuizVideoSelection(this.firestore, {
        videoProfileId: this.youtube[this.position].id,
        candidateSelected: this.candidateSelected,
        videoUrl: url,
        isCorrect: this.candidateSelected == this.youtube[this.position].demographics.candidate
      });
      // check if user was right
      this.answersCounter += 1;
      this.allAnswersCounter += 1;
      const random = Math.floor(Math.random() * 3);
      this.itemclass = url;
      if (this.candidateSelected == this.youtube[this.position].demographics.candidate) {
        this.correctCounter += 1;
        this.allCorrectCounter += 1;
        this.feedback += this.goodGuess[random]
        audioCorrectAnswer.play();
        fireConfetti(2.5, {
          spread: 300,
          startVelocity: 45,
        });
      }  else {
        audioIncorrectAnswer.play();
        this.feedback += this.badGuess[random]
      }
      this.showDemographics = true;
      if (this.youtube[this.position].demographics.candidate == 'Biden') {
        this.bgColor = '#5588D5';
      } else {
        this.bgColor = '#D5564C';
      }
      this.askSelectVideo = false;
    }
    this.updateScore();
  }

  next() {
    this.showDemographics = false;
    this.askSelectVideo = false;
    this.candidateSelected = '';
    console.log(this.position)
    console.log(this.youtube.length)
    if (this.position < this.youtube.length- 1) {
      console.log('here')
      this.position += 1;
      this.youtubeThumbnails = []
      this.getYoutubeVideos()
      this.getYoutubeThumbnail()
      this.bgColor = '#f3de16'
      this.feedback = '';
    }
    else {
      console.log('Done');
    }
    this.itemclass  ='';
  }

}
